<template>
  <div>
    <statistics-bar :entries="barEntries" />
  </div>
</template>

<script>
const StatisticsBar = require("@/modules/core/components/StatisticsBar.vue")
  .default;
import Moment from "moment";

export default {
  name: "StatisticEntries",
  data() {
    return {
      start: null,
      barEntries: []
    };
  },
  props: {
    firstDate: {
      type: Moment
    },
    range: {
      type: Number
    },
    entries: {
      type: Array
    },
    type: {
      type: String,
      default: "day"
    }
  },
  components: {
    StatisticsBar
  },
  methods: {},
  computed: {},
  created() {
    if (this.firstDate) {
      this.start = Moment(this.firstDate);
    } else if (this.range) {
      this.start = Moment().subtract(this.range, "d");
    }

    let runningDate = this.start;
    while (runningDate.isSameOrBefore(Moment())) {
      let value = 0;
      let el;
      if (this.type === "day") {
        el = this.entries.find(e => {
          return Moment(e.date, "YYYY-M-DD").isSame(runningDate, "d");
        });
      } else if (this.type === "week") {
        el = this.entries.find(e => {
          let dateSplit = e.date.split("-");
          return (
            Moment(dateSplit[0], "YYYY").isSame(runningDate, "year") &&
            parseInt(dateSplit[1]) + 1 == runningDate.week()
          );
        });
      }
      if (el) {
        value = el.value;
      }
      this.barEntries.push(value);

      const tempDate = Moment(runningDate);
      runningDate.add(1, this.type);
      if (
        runningDate.isAfter(Moment()) &&
        !Moment().isSame(tempDate, this.type)
      ) {
        runningDate = Moment();
      }
    }
  }
};
</script>